module.exports = __webpack_public_path__ + "static/media/02-eCSPlus-wh_4x.b75e1c64.png";